import { Injectable } from '@angular/core';
import { databases, ID } from '../config/appwrite';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TiposDocumentoService {

  private collectionId = "t_documentos_identificaciones";
  private DATABASE_NAME = environment.databaseName;

  constructor() { }


  getTiposDocumento(){
    return databases.listDocuments(
      this.DATABASE_NAME,
      this.collectionId
    );
  }

}
